export default {
  new: {
    head: 'Nueva versión de Binnacle',
    message: 'Una nueva versión está disponible para descargar. Es necesario que la instales desde la'
  },
  security: {
    passwordChange: 'Tienes que cambiar tu contraseña por una más segura',
    goToProfile: 'Ir a Perfil'
  },
  updateAvailable: 'Actualización disponible',
  update: 'Actualizar',
  storeUnavailable: 'No se pudo abrir la tienda de aplicaciones en este dispositivo'
}
